var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBadgeKhc(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.89209 17.5088C6.8858 17.5088 5.39489 15.9613 5.39489 13.9125C5.39489 11.9654 7.23552 9.45887 10.2781 9.45887C14.7195 9.45887 15.9436 13.295 16.1681 14.2104H24C23.6098 7.78785 17.6406 3 10.5431 3C3.06465 3 0 9.38077 0 13.1388C0 17.9012 3.68127 21.8571 8.30125 21.8571C11.8813 21.8571 15.2294 19.663 15.2294 15.7779C15.2294 12.4395 13.0004 10.5105 10.1971 10.5105C8.21658 10.5105 6.51584 12.098 6.46062 14.0233C6.46062 14.0542 6.46062 14.1777 6.46062 14.2049H7.02201C7.02201 14.2049 7.44167 12.3795 9.44796 12.3596C10.6665 12.3468 11.9439 13.344 11.9015 15.0168C11.8739 16.1684 10.8597 17.5034 8.89577 17.5034",
    fill: "#B1292F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBadgeKhc);
export default __webpack_public_path__ + "static/media/badge-khc.d0daa3389147e6a89cde4780e39593a7.svg";
export { ForwardRef as ReactComponent };